import * as React from "react";
export class Bases extends React.PureComponent {
    render() {
        return (this.props.bases.map((base, index) => {
            let activeClass = this.props.activeBases.indexOf(base) !== -1 ? "rj-baseball-scoreboard-base--active" : "";
            let clsName = `rj-baseball-scoreboard-base rj-baseball-scoreboard-base-${base} ${activeClass}`;
            return (React.createElement("span", { className: clsName, key: `${this.props.baseKey}-base-${index}` }));
        }));
    }
}
//# sourceMappingURL=Bases.js.map